/* eslint-disable react/no-array-index-key */
import React from "react";
import { TableBody } from "@mui/material";
import { TableRowComponent } from "./TableRowComponent";

export const TableBodyComponent = ({ data, style }: any) => {

  return (
    <TableBody>
      {data.map((item: any, index: number) => (
        <TableRowComponent key={index} rowList={item} style={style} />
      ))}
    </TableBody>
  );
};
